/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Semantic operation used when no registered deterministic outcome exists.
 */
export type EmployeeExecutionSemanticOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionSemanticOperation.kind;
    /**
     * Atomic business instruction evaluated by Executor and Validator.
     */
    instruction: string;
};
export namespace EmployeeExecutionSemanticOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        SEMANTIC = 'semantic',
    }
}

